import script from "./CmsTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./CmsTest.vue?vue&type=script&setup=true&lang=ts"

import "./CmsTest.vue?vue&type=style&index=0&id=642dee47&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642dee47"]])

export default __exports__